import { styled } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';

export const LoadingPage = styled(CircularProgress)({
  marginTop: '50px',
  color: '#f76d31',
});

export const LoadingButton = styled(CircularProgress)({
  margin: '0 0 0 8px',
  color: 'white',
});
